// project imports
import { ActionResponseType } from "../../../common/types/common.types";
import { ApiClient } from "../../../core/api/apiClient.service";
import {
  DeleteTemplateParameterType,
  Inspection,
  ViewInspectionPageParameterType,
} from "./ViewInspectionPage.type";

// ==============================|| VIEWS - PAGES - VIEWINSPECTION - API ||============================== //

// client object for axios calls to backend
const client = new ApiClient();

export const getInspectonsByTemplateIdAPi = async (
  Params: ViewInspectionPageParameterType
): Promise<Inspection> => {
  try {
    const URL: string = `InspectionSet/GetInspectonsByTemplateId`;
    const response = await client.post<ActionResponseType>(URL, Params);

    return {
      ...response.Data,
    } as Inspection;
  } catch (error) {
    // Optional: log or handle error
    return {} as Inspection;
  }
};

export const deleteInspectonsByTemplateIdAPi = async (
  Params: DeleteTemplateParameterType
): Promise<any> => {
  try {
    const URL: string = `InspectionSet/DeleteInspectonsByTemplateId`;
    const response = await client.post<ActionResponseType>(URL, Params);

    return response;
  } catch (error) {
    // Optional: log or handle error
    return {};
  }
};
